export default __webpack_public_path__ + "static/media/98.1b51312c.png";